import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AdoptionService {
  private http = inject(HttpClient);

  private baseUrl = `${environment.apiUrl}/adoption`;

  createAdoption(data: any) {
    return this.http.post(this.baseUrl, data);
  }

  getAllAdoptions() {
    return this.http.get(this.baseUrl);
  }

  getAdoption(id: string) {
    return this.http.get(`${this.baseUrl}/${id}`);
  }

  completeAdoption(
    id: string,
    data: {
      definitiveStartDate: string;
      definitiveComments: string;
    },
  ) {
    return this.http.patch(
      `${this.baseUrl}/${id}/complete`,
      data,
    );
  }
}